import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'helpers/verify';
import { FilterTree } from 'components/ReusableFilters/FilterTree';
import css from '../../Search.scss';

export class MultiSelectFilterOptions extends React.Component {
  onToggleItem = item => {
    const { onToggle, filterName } = this.props;

    onToggle(filterName, item);
  };

  render() {
    const { selectedItems, parentedItemIds, items } = this.props;

    return (
      !isEmpty(items) && (
        <FilterTree
          baseClassName={css.Search__multiSelect}
          toggleItemId={this.onToggleItem}
          itemIdSelected={selectedItems}
          parentedItemIds={parentedItemIds}
          itemsById={items}
          parentIdExpanded={{}}
          parentIdPartialSelected={{}}
        />
      )
    );
  }
}

MultiSelectFilterOptions.propTypes = {
  items: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.shape({
        id: PropTypes.string,
        defaultMessage: PropTypes.string,
      }),
    })
  ).isRequired,
  onToggle: PropTypes.func.isRequired,
  parentedItemIds: PropTypes.shape({
    root: PropTypes.arrayOf(PropTypes.string),
  }),
  selectedItems: PropTypes.object.isRequired,
  filterName: PropTypes.string.isRequired,
};
